import React, { Component, Suspense, lazy } from 'react';
import Layout from './components/Layout/';
import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './Apps.scss';

import { componentRoutes } from './routes';
const NotFound = lazy(() => import('./pages/NotFound'));
const SplashScreen = lazy(() => import('./pages/SplashScreen'));

class App extends Component {
    render() {
        const helmetContext = {};

        return (
            <HelmetProvider context={helmetContext}>
                <Suspense fallback={<div>loading...</div>}>
                    <Routes>
                        {componentRoutes.map((route, idx) =>
                            route.isWithoutLayout ? (
                                <Route
                                    path={route.path}
                                    key={idx}
                                    element={<route.element />}
                                />
                            ) : (
                                <Route
                                    path={route.path}
                                    key={idx}
                                    element={
                                        <Layout>
                                            <route.element />
                                        </Layout>
                                    }
                                />
                            )
                        )}

                        <Route
                            path="/success-page"
                            element={<SplashScreen />}
                        />

                        <Route
                            path="*"
                            element={<NotFound />}
                        />
                    </Routes>
                </Suspense>
            </HelmetProvider>
        );
    }
}

export default App;
